import React, { useEffect } from 'react'
import { Grid, makeStyles, Slider } from '@material-ui/core'
import './styles.css'
import {
  formatNumberInput,
  formatNumberInputNotDecimal,
} from './ScenarioRenderType'

const useStyles = makeStyles({
  contentInputScenario: {
    padding: '16px 16px 0 16px',
  },
  titleInputScenario: {
    color: '#1B3963',
    fontSize: 12,
    fontHeight: 18,
    fontWeight: 600,
  },
  divInputSearch: {
    marginTop: 5,
    paddingBottom: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    borderBottom: '1px solid #DFE4EB',
  },
  textValueSlide: {
    fontSize: 12,
    fontWeight: 600,
    fontHeight: 18,
    color: '#496182',
  },
  inputSearch: {
    // width: 'calc(100% - 140px)',
    height: 30,
    width: '60px !important',
    backgroundColor: '#FFFFFF',
    // outline: 'none',
    border: '2px solid #DFE4EB !important',
    // fontSize: 14,
    paddingRight: '15px',
    paddingLeft: '20px',
  },
  divSliderContent: {
    marginTop: 5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sliderNegative: {
    '& .MuiSlider-thumb': {
      color: '#3393F3',
      '&+.MuiSlider-thumb': {
        display: 'none',
      },
    },
    '& .MuiSlider-track': {
      color: '#3393F3',
    },
  },
  sliderPositive: {
    '& .MuiSlider-thumb': {
      display: 'none',
      '&+.MuiSlider-thumb': {
        display: 'flex',
        color: '#3393F3',
      },
    },
    '& .MuiSlider-track': {
      color: '#3393F3',
    },
  },
  customSlider: {
    // width: '70%',
    color: '#3393F3',
    '& .MuiSlider-rail': {
      width: '100%',
      height: '6px',
      display: 'block',
      opacity: '1',
      position: 'absolute',
      borderRadius: '1px',
      backgroundColor: '#FFFFFF',
      color: '#1B3963',
    },
    '& .MuiSlider-track': {
      border: 'none',
      height: '6px',
      borderRadius: '3px',
    },
    '& .MuiSlider-thumb': {
      height: 16,
      width: 16,
      backgroundColor: '#fff',
      border: '3px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&::before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: '#52af77',
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&::before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  },
})

const ScenarioInput = ({
  valueScenario,
  title = 'Short term Debt',
  attribute,
  setDataByCode = () => {},
  isResetData,
  isDisabledAction = false,
  valueScenarioNew = null,
}) => {
  const classes = useStyles()
  const [value, setValue] = React.useState(
    valueScenarioNew ?? valueScenario ?? '',
  )
  const [valueSlider, setValueSlider] = React.useState(0)
  let baseValue = 0
  const handleChange = newValue => {
    if (typeof newValue === 'number') {
      setValueSlider(newValue)
      if (newValue !== null) {
        let cal =
          parseFloat(valueScenarioNew ?? valueScenario) +
          (parseFloat(valueScenarioNew ?? valueScenario) * newValue) / 100

        setValue(parseFloat(cal))
      }
      if (newValue == 0) {
        setValue(valueScenarioNew ?? valueScenario)
      }
    }
  }

  useEffect(() => {
    if (valueScenario === 0) {
      setDataByCode(attribute, 0, value)
    } else {
      setDataByCode(attribute, valueSlider / 100 ?? 0, value)
    }
  }, [valueSlider, value])

  useEffect(() => {
    if (isResetData) {
      setDataByCode(attribute, 0, value)
      setValueSlider(0)
      setValue(valueScenario ?? '')
    }
  }, [isResetData])

  return (
    <div className={classes.contentInputScenario}>
      <div style={{ paddingRight: 10, fontSize: 14 }}>
        <span className={classes.titleInputScenario}>{title}</span>
      </div>
      <Grid container className={classes.divSliderContent}>
        <Grid
          item
          xs={10}
          sm={10}
          style={{
            paddingRight: '10px',
          }}
        >
          <Slider
            value={[
              valueSlider < baseValue ? valueSlider : baseValue,
              valueSlider > baseValue ? valueSlider : baseValue,
            ]}
            onChange={(e, value) => {
              handleChange(value[0] !== baseValue ? value[0] : value[1])
            }}
            className={`${
              valueSlider < baseValue
                ? classes.sliderNegative
                : classes.sliderPositive
            } ${classes.customSlider}`}
            min={-50}
            max={50}
            disabled={valueScenario === null || isDisabledAction}
          />
        </Grid>
        <Grid
          item
          xs={2}
          sm={2}
          className={'input-value-slider'}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
          }}
        >
          <input
            value={valueSlider !== 0 ? valueSlider : null}
            type="text"
            disabled={true}
            className={`${classes.inputSearch} `}
            data-placeholder="%"
          />
        </Grid>
      </Grid>
      <div className={classes.divInputSearch}>
        <Grid container>
          <Grid item xs={6} sm={6}>
            <span className={classes.textValueSlide}>
              Current: {formatNumberInputNotDecimal(valueScenario, attribute)}
            </span>
          </Grid>
          <Grid item xs={6} sm={6}>
            <span className={classes.textValueSlide}>
              New:{' '}
              <span style={{ color: '#3393F3' }}>
                {formatNumberInputNotDecimal(value, attribute)}
              </span>
            </span>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default React.memo(ScenarioInput)
